import NP from 'number-precision'

/**
 * 加法
 * @param arg1
 * @param arg2
 * @returns {number}
 */
export function accAdd(arg1, arg2) {
  return NP.plus(arg1, arg2)
}

/**
 * 减法
 * @param arg1
 * @param arg2
 * @returns {number}
 */
export function accSub(arg1, arg2) {
  return NP.minus(arg1, arg2)
}

/**
 * 乘法
 * @param arg1
 * @param arg2
 * @returns {number}
 */
export function accMul(arg1, arg2) {
  return NP.times(arg1, arg2)
}

/**
 * 除法
 * @param arg1
 * @param arg2
 * @returns {number}
 */
export function accDiv(arg1, arg2) {
  return NP.divide(arg1, arg2)
}
